const extractDateFromPath = (path: string) =>
  path.match(/\d{4}-\d{2}/) ? path.match(/\d{4}-\d{2}/)?.[0] || '' : '';

export const extractMonthFromPath = (path: string) => {
  return { key: extractDateFromPath(path).split('-')[1] };
};

export const extractYearFromPath = (path: string) => extractDateFromPath(path).split('-')[0];
